import { LoadingSpinner } from "components/loadingSpinner";
import { FC, PropsWithChildren, Suspense } from "react";

export const SuspenseWrapper: FC<PropsWithChildren> = ({ children }) => (
  <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>
);
